import { BADGE_COLORS } from "../../../components/ui/badgeColors";
import { ORDER_STATE } from "../../../config/constants";
import OrderStates from "../../../utils/OrderStates";
import Utils from "../../../utils/Utils";
import { VALOR_VACIO } from "../utils/formatters";

/**
 * Helpers del listado de estados de ventas: filas del DataGrid, color y etiqueta por estado.
 */

// Mismos valores que la regla global .include de src/scss/_custom.scss
export const COLOR_FILA_MOSTRADOR = { fondo: "#b8daba", texto: "#1a3e72" };
export const CLASE_FILA_MOSTRADOR = "fila-mostrador";

// DECISION: mismo mapa que COLOR_ESTADO_PEDIDO de colas. El verde es para FINALIZADO, el único
// estado que cierra el documento; PREPARADO va en TEAL porque aún le queda la revisión.
// Cualquier otro estado es GRAY (el legacy lo pintaba de verde).
export const COLOR_ESTADO_VENTA = {
    [ORDER_STATE.SIN_PREPARAR]: BADGE_COLORS.BLUE,
    [ORDER_STATE.EN_PREPARACION]: BADGE_COLORS.RED,
    [ORDER_STATE.PREPARADO]: BADGE_COLORS.TEAL,
    [ORDER_STATE.EN_REVISION]: BADGE_COLORS.AMBER,
    [ORDER_STATE.FINALIZADO]: BADGE_COLORS.GREEN,
};

/**
 * Color de la paleta para un estado de venta; GRAY si es nulo, vacío o desconocido
 */
export const getColorEstadoVenta = (estado) =>
    COLOR_ESTADO_VENTA[String(estado ?? "")] || BADGE_COLORS.GRAY;

/**
 * Etiqueta legible del estado (valor crudo si es desconocido, "-" si no hay)
 */
export const getEtiquetaEstadoVenta = (estado) =>
    estado === null || estado === undefined || estado === ""
        ? VALOR_VACIO
        : OrderStates.getState(estado);

/**
 * Convierte las ventas del backend en filas del DataGrid sin mutarlas.
 * id = tipo-serie-pedido (una fila por documento; almacen es atributo del documento).
 */
export const prepararFilasEstadosVentas = (ventas, getNombreAlmacen) => {
    if (!Array.isArray(ventas)) return [];
    return ventas.map((venta) => {
        const etiqueta = venta.EtiquetasModels?.[0];
        return {
            ...venta,
            id: `${venta.tipo}-${venta.serie}-${venta.pedido}`,
            numero: `${venta.serie}-${venta.pedido}`,
            ruta: etiqueta?.ruta ?? null,
            cliente: etiqueta?.cliente ?? null,
            nave: getNombreAlmacen(venta.almacen),
            esMostrador: Utils.getTransport(venta.transporte),
        };
    });
};

/**
 * Href de la ficha del pedido (HashRouter), con los valores codificados.
 * DECISION: el legacy no codificaba; encodeURIComponent evita romper la URL con caracteres especiales.
 */
export const getEnlaceInfoEstadoVenta = ({ tipo, serie, pedido }) => {
    const clave = encodeURIComponent(tipo);
    return `#/listado-estados/info/?tipo=${clave}&${clave}=${encodeURIComponent(`${serie}-${pedido}`)}`;
};

// El backend puede devolver el código de almacén sin ceros ("1"); la paleta usa "01"
export const normalizarCodigoAlmacen = (codigo) =>
    codigo === null || codigo === undefined || codigo === "" ? "" : String(codigo).padStart(2, "0");
